<template>
  <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.9668 5.6668C1.9668 5.2802 2.2802 4.9668 2.6668 4.9668H5.33346C5.66714 4.9668 5.95443 5.20232 6.01987 5.52952L6.68654 8.86285C6.73244 9.09235 6.6606 9.32961 6.4951 9.4951L4.69497 11.2952C5.06016 11.935 5.49564 12.5057 5.9951 13.0052C6.49457 13.5046 7.06524 13.9401 7.70502 14.3053L9.50516 12.5052C9.67065 12.3397 9.90791 12.2678 10.1374 12.3137L13.4707 12.9804C13.7979 13.0458 14.0335 13.3331 14.0335 13.6668V16.3335C14.0335 16.7201 13.7201 17.0335 13.3335 17.0335C9.85977 17.0335 6.99866 15.9886 5.00516 13.9951C3.01165 12.0016 1.9668 9.14049 1.9668 5.6668ZM9.05714 14.9331C10.1103 15.3226 11.3045 15.5571 12.6335 15.6177V14.2407L10.2302 13.76L9.05714 14.9331ZM4.06719 9.94312L5.24025 8.77006L4.7596 6.3668H3.38253C3.44312 7.6958 3.67766 8.88999 4.06719 9.94312Z" 
      :fill="active ? '#1677FF' : '#262626'" fill-opacity="0.88"/>
  </svg>
</template>

<script>
export default {
  props: {
    active: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
};
</script>
